// extracted by mini-css-extract-plugin
export default {"searchBarContainer":"SearchBarAdmin_searchBarContainer__tYhCP","searchBarButton":"SearchBarAdmin_searchBarButton__dByp7","searchBarInput":"SearchBarAdmin_searchBarInput__bPWnd"};